import parse from 'html-react-parser';

/**
 * Parses HTML strings into React nodes
 * @param htmlString - The HTML string to parse
 * @returns React nodes or null if input is undefined
 */
export const parseHtml = (htmlString: string | undefined): React.ReactNode => {
  if (!htmlString) return null;
  return parse(htmlString);
};
